module.exports = __webpack_public_path__ + "static/media/70-points.d4a37108.png";